import { render, staticRenderFns } from "./LinkApp.vue?vue&type=template&id=9e93a928&scoped=true&"
import script from "./LinkApp.vue?vue&type=script&lang=js&"
export * from "./LinkApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e93a928",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseLinkApp: require('/app/components/base/LinkApp.vue').default})
